import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-crm-reportes',
  templateUrl: './crm-reportes.component.html',
  styleUrls: ['./crm-reportes.component.scss']
})
export class CrmReportesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
